<template>
  <div>
    <p v-html="$t('rc_resume_admin_info')" />
  </div>
</template>
